import { Fragment } from 'react';

import useHqLscOfferingInstanceOrgUnitAdd from './UseHqLscOfferingInstanceOrgUnitAdd';

import HqOfferingManagementContextLoadingModal from '../../HqOfferingManagementContextLoadingModal';

import OfferingInstanceOrgUnitAddForm from '../../../components/forms/offeringInstanceOrgUnit/OfferingInstanceOrgUnitAddForm';
import OfferingInstanceOrgUnitAddAdditionalForm from '../../../components/forms/offeringInstanceOrgUnit/OfferingInstanceOrgUnitAddAdditionalForm';

import { ADD_VIEW_TYPE_ADDITIONAL_OFFERING, ADD_VIEW_TYPE_NEW_OFFERING } from '../../../utils/OfferingManagementConstants';

import Headings from '@usas/ui-web/components/headings/Headings';

import { SAVING_MSG } from '@usas/ui-web/utils/Constants';

const HqLscOfferingInstanceOrgUnitAdd = () => {
  const {
    isSaving,
    state,
    onSubmitOfferingInstanceOrgUnitForm,
    onBackClicked
  } = useHqLscOfferingInstanceOrgUnitAdd();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>{state.viewType === ADD_VIEW_TYPE_ADDITIONAL_OFFERING ? 'Add Offering Period' : 'Add LSC Offering'}</Headings.H3>
        </div>
      </div>
      {state.viewType === ADD_VIEW_TYPE_NEW_OFFERING
        ? (
          <OfferingInstanceOrgUnitAddForm
            reportPeriodObj={state.reportPeriodObj}
            orgUnitObj={state.orgUnitObj}
            hideOrgUnitName={false}
            submitButtonText='Add LSC Offering'
            onSubmitFormCallback={onSubmitOfferingInstanceOrgUnitForm}
            onBackClicked={onBackClicked} />
        ) : state.viewType === ADD_VIEW_TYPE_ADDITIONAL_OFFERING
          ? (
            <OfferingInstanceOrgUnitAddAdditionalForm
              offeringInstanceObj={state.offeringInstanceObj}
              reportPeriodObj={state.reportPeriodObj}
              orgUnitObj={state.orgUnitObj}
              hideOrgUnitName={false}
              submitButtonText='Add Offering Period'
              onSubmitFormCallback={onSubmitOfferingInstanceOrgUnitForm}
              onBackClicked={onBackClicked} />
          ) : <Fragment />
      }
      <HqOfferingManagementContextLoadingModal
        isLoading={isSaving}
        loadingMessage={SAVING_MSG}
        isError={state.pageErrorMessage !== ''}
        errorMessage={state.pageErrorMessage} />
    </Fragment>
  );
};

export default HqLscOfferingInstanceOrgUnitAdd;